/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Header Icons
 */
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from 'antd';
import { Help, Remind, Setting } from '@icon-park/react';

import { VARIABLES } from 'styles/theme';
import { getAppLogo } from 'utils/assets';
import { getHomePath, getSettingsPath } from 'utils/router';
import { AntClass } from '@veritable/common/constants/antd';

/**
 * App Logo
 */
const APP_LOGO = (
	<Link to={getHomePath()} className='flex items-center leading-normal'>
		<img src={getAppLogo()} alt='logo' className='h-5.5 max-h-5.5 w-auto' />
	</Link>
);

/**
 * Help Icon
 */
const HelpIcon: React.FC<ButtonProps> = (props) => {
	return <Button type='text' icon={<Help theme='filled' size={20} />} style={{ color: VARIABLES.ICON_COLOR }} {...props} />;
};

/**
 * Settings Icon
 */
const SettingsIcon: React.FC<ButtonProps> = (props) => {
	return (
		<Link to={getSettingsPath()} className='leading-normal'>
			<Button type='text' icon={<Setting theme='filled' size={20} />} style={{ color: VARIABLES.ICON_COLOR }} {...props} />
		</Link>
	);
};

/**
 * Notification Icon
 */
const NotificationIcon: React.FC<ButtonProps> = (props) => {
	return <Button type='text' icon={<Remind theme='filled' size={20} />} style={{ color: VARIABLES.ICON_COLOR }} {...props} />;
};

/**
 * User Options Icon
 */
const UserOptions: React.FC<ButtonProps> = (props) => {
	return <Button shape='circle' type='primary' className={AntClass.secondaryButton} {...props} />;
};

/**
 * Header Icons
 */
const HeaderIcons = {
	Help: HelpIcon,
	Settings: SettingsIcon,
	Notification: NotificationIcon,
	UserOptions,
};

export { APP_LOGO, HeaderIcons };
